import React, { useContext } from 'react';

import AidsList from './lists/aids-list';
import EadDetailList from './lists/ead-detail-list';

import { useVariantContext } from './context/variant-context';
import CollectionList from './lists/collections-list';
import { HierarchyContext } from './context/hierarchy-context';

export const GridLeftPanel = () => {
  const { eadId } = useContext(HierarchyContext);
  const variant = useVariantContext();

  if (eadId) {
    return <EadDetailList id={eadId} />;
  }
  if (variant === 'aids') {
    return <AidsList />;
  }
  if (variant === 'funds') {
    return <CollectionList />;
  }
  return <div />;
};
